import { createContext, useContext } from 'react';

/**
 * The right-hand end of the phone layout's top bar, for the screen inside to
 * put its own actions in (the room's End session). Null outside the phone
 * layout, or before the bar has mounted.
 */
export const MobileHeaderSlot = createContext<HTMLElement | null>(null);

export function useMobileHeaderSlot(): HTMLElement | null {
  return useContext(MobileHeaderSlot);
}
